module.exports = __webpack_public_path__ + "img/document-download-outline-white.235ae03c.svg";